module.exports = __webpack_public_path__ + "fonts/6fe0c76234ce33a0675165aa1400398b.svg";